import { useSelector } from "react-redux";
import { RootState } from "../store";
import { UIConfig } from "../types/UIConfig";

export type VariableWords = Pick<
  UIConfig["variableWords"],
  "school" | "checkEligibility"
>;

export const DEFAULT_VARIABLE_WORDS: VariableWords = {
  school: {
    singular: {
      label: "school",
    },
    plural: {
      label: "school",
    },
  },
  checkEligibility: {
    label: "check eligibility",
  },
};

export const useVariableWords = (): VariableWords => {
  const config = useSelector((state: RootState) => state.config);

  return config.state !== "finished"
    ? DEFAULT_VARIABLE_WORDS
    : config.values.variableWords;
};
